const baseUrl = "/apps/sso/moas/rest/users/migration";

var myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");

document
  .querySelectorAll(".mo-form input").forEach(box => {
  box.addEventListener("keypress", function (event) {

    if(event.keyCode==13) {
      // Enter inside a field would otherwise submit the page natively, for the same
      // reason as the button above.
      event.preventDefault();
      redirectToIdpRegister();
    }
  })
});


document
  .querySelector("button.mo-sso")
  .addEventListener("click", function (event) {
      // The button carries no type attribute, so the browser treats it as a submit.
      // Left alone that navigates to the form action as a GET, which /initiate does
      // not accept - the shopper lands on an error page instead of signing in.
      event.preventDefault();
      moFormSSO();
  });

function moFormSSO() {

    document.getElementById("email-error").innerHTML = "";
    document.getElementById("otp-error").innerHTML = "";
    document.getElementById("not-found-error").innerHTML = "";

    // Perform validation
    var username = document.querySelector(
      `input[name='mo-email']`
    ).value;

    var encodeUsername = encodeURIComponent(username);

    // Second pass: the passcode field is showing, so a code has been emailed. Nothing
    // to check client-side - /initiate verifies the passcode itself as the first step
    // of the migration.
    if (document.querySelector('button.mo-sso').classList.contains("mo-sso-not-found")) {
      var otp = document.querySelector(`input[name='mo-otp']`).value;

      if (username.trim() === "") {
        document.getElementById("otp-error").innerHTML =
          "Email is required";
      } else if (otp.trim() === "") {
        document.getElementById("otp-error").innerHTML =
          "Passcode is required";
      } else {
        submitMigration(username, otp);
      }
      return;
    }

    if (username.trim() === "") {
      document.getElementById("email-error").innerHTML =
        "Email is required";
      return;
    }

    var raw = `{\n    \"shop\" : \"${window.location.host}\",\n    \"email\" : \"${username}\"\n}`;

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(baseUrl.concat("/validate/email"), requestOptions)
      .then((response) => {
        // The endpoint answers 200 with a JSON body when the address belongs to this
        // store, and a bare 404 when it does not. Read the outcome here and hand a
        // plain value onward, so that nothing thrown further down the chain can be
        // mistaken for "no such customer".
        if (!response.ok) {
          return { known: false };
        }
        return response.json().then((body) => ({ known: true, body: body }));
      })
      .catch((error) => {
        // Network failure or an unreadable body. Genuinely unknown, so say so rather
        // than claiming the shopper has no account.
        console.log("error", error);
        return { failed: true };
      })
      .then((outcome) => {
        if (outcome.failed) {
          document.getElementById("email-error").innerHTML =
            "Could not reach the server. Please try again.";
          return;
        }

        if (!outcome.known) {
          showRegisterLink();
          return;
        }

        if (outcome.body.migrationStatus) {
          // Already migrated - straight to the IdP, no passcode needed.
          window.location.href = `https://auth.sonyworld.ae/moas/broker/login/shopify/${window.location.host}/account?idpname=custom_oauth_loginmdcim&login_hint=${encodeUsername}`;
          return;
        }

        // Known customer, not yet migrated: challenge them by passcode.
        sendOtp(username);
      });
}

function showRegisterLink() {
  document.getElementById("not-found-error").innerHTML =
    `Account does not exist, Please <a href="https://auth.sonyworld.ae/moas/broker/login/shopify/${window.location.host}/account?idpname=custom_oauth_signupmdcim" style="margin: 0px 10px;">click here</a> to register`;
}

/**
 * Asks the server to email a passcode, then reveals the passcode field.
 *
 * Only reached for a shopper the store recognises who has not yet been migrated -
 * the email lookup above has established both.
 */
function sendOtp(username) {

  var raw = `{\n    \"shop\" : \"${window.location.host}\",\n    \"email\" : \"${username}\"\n}`;

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  var button = document.querySelector('button.mo-sso');
  button.disabled = true;

  fetch(baseUrl.concat("/otp/send"), requestOptions)
    .then((response) => {
      button.disabled = false;

      if (!response.ok) {
        document.getElementById("otp-error").innerHTML =
          "Could not send the passcode. Please try again.";
        return;
      }

      // Reveal the passcode field and switch the button into "submit passcode" mode.
      document
        .querySelector(".field.mo-otp")
        .removeAttribute("style");
      document
        .querySelector("a.mo-resend-otp")
        .removeAttribute("style");
      button.classList.add("mo-sso-not-found");

      document.getElementById("otp-sent-message").innerHTML =
        "We have emailed a passcode to " + username + ".";
    })
    .catch((error) => {
      button.disabled = false;
      document.getElementById("otp-error").innerHTML =
        "Could not send the passcode. Please try again.";
      console.log("error", error);
    });
}

/**
 * Verifies the passcode, then hands the migration to the server.
 *
 * Two steps, because they need opposite things. Verification has to answer back here so a mistyped
 * passcode can be shown on the form - fetch does that. The migration has to redirect into the IdP
 * and come back to a callback that reads the session, and only a real top-level form post carries
 * the session cookie that far; a fetch would create a session the browser never keeps, and the
 * callback would find nothing.
 *
 * Splitting them would let the address be changed after the passcode was proved, so verification
 * returns a token naming the address it was issued for. /initiate migrates only the address inside
 * that token, so editing the field afterwards invalidates it rather than redirecting the migration
 * at someone else's account.
 */
function submitMigration(username, otp) {

  var button = document.querySelector('button.mo-sso');
  button.disabled = true;
  document.getElementById("otp-error").innerHTML = "";

  var raw = `{
    \"shop\" : \"${window.location.host}\",
    \"email\" : \"${username}\",
    \"otp\" : \"${otp}\"
}`;

  fetch(baseUrl.concat("/otp/verify"), {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  })
    .then((response) => {
      if (response.status === 401) {
        showPasscodeError();
        return;
      }

      if (!response.ok) {
        showMigrationError();
        return;
      }

      return response.json().then((data) => {
        if (!data || !data.otpToken) {
          showMigrationError();
          return;
        }
        // Proved. The passcode is spent now, so the migration travels on the token instead.
        nativeSubmit(username, data.otpToken);
      });
    })
    .catch((error) => {
      console.log("error", error);
      showMigrationError();
    });
}

/** Reports a bad passcode on the form, leaving both fields as the shopper typed them. */
function showPasscodeError() {
  var button = document.querySelector('button.mo-sso');
  button.disabled = false;
  document.getElementById("otp-error").innerHTML =
    "That passcode is not correct. Please check it and try again, or request a new one.";
  document.querySelector(`input[name='mo-otp']`).focus();
}

/** Reports a failure the shopper cannot fix by retyping the passcode. */
function showMigrationError() {
  var button = document.querySelector('button.mo-sso');
  button.disabled = false;
  document.getElementById("otp-error").innerHTML =
    "Something went wrong completing sign-in. Please request a new passcode and try again.";
}

/**
 * The top-level form post that runs the migration.
 *
 * Deliberately a real navigation, not fetch: /initiate redirects into the IdP and the journey ends
 * at a callback that needs the session cookie this post establishes.
 */
function nativeSubmit(username, otpToken) {
  document.querySelector(`#mo-login-form-xecurify input[name='email']`).value = username;
  document.querySelector(`#mo-login-form-xecurify input[name='otpToken']`).value = otpToken;
  document.querySelector(`#mo-login-form-xecurify input[name='shop']`).value = window.location.host;
  document.querySelector('form#mo-login-form-xecurify').submit();
}


document
  .querySelector("a.mo-resend-otp")
  .addEventListener("click", function (event) {
    event.preventDefault();
    document.getElementById("otp-error").innerHTML = "";
    document.getElementById("otp-sent-message").innerHTML = "";
    sendOtp(document.querySelector(`input[name='mo-email']`).value);
  });


function openRegisterModal() {
  const modal = document.querySelector(".mo-modal-register");
  const overlay = document.querySelector(".mo-overlay");

  // open modal event
  openModal(modal, overlay);
}

function closeRegisterModal() {
  const modal = document.querySelector(".mo-modal-register");
  const overlay = document.querySelector(".mo-overlay");

  // open modal event
  closeModal(modal, overlay);
}




// open modal function
const openModal = function (modal, overlay) {
  modal.classList.remove("mo-hidden");
  overlay.classList.remove("mo-hidden");
};

// close modal function
const closeModal = function (modal, overlay) {
  modal.classList.add("mo-hidden");
  overlay.classList.add("mo-hidden");
};



function redirectToIdpRegister() {
  const email = document.querySelector("#mo-RegisterForm-email").value;
  var encodeUsername = encodeURIComponent(email);
  var raw = `{\n    \"shop\" : \"${window.location.host}\",\n    \"email\" : \"${email}\"\n}`;

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(baseUrl.concat("/validate/email"), requestOptions)
          .then((response) => {
            if (!response.ok) {
              return { known: false };
            }
            return response.json().then((body) => ({ known: true, body: body }));
          })
          .catch((error) => {
            // Caught before the branch below, so only a failed lookup lands here -
            // never an error thrown while acting on a successful one.
            console.log("error", error);
            return { failed: true };
          })
          .then((outcome) => {
            if (outcome.failed) {
              return;
            }

            if (!outcome.known) {
              window.location.href = `https://auth.sonyworld.ae/moas/broker/login/shopify/${window.location.host}/account?idpname=custom_oauth_signupmdcim`;
              return;
            }

            if (outcome.body.migrationStatus) {
              window.location.href = `https://auth.sonyworld.ae/moas/broker/login/shopify/${window.location.host}/account?idpname=custom_oauth_loginmdcim&login_hint=${encodeUsername}`;
              return;
            }

            document.querySelector(
              `input[name='mo-email']`
            ).value = email;
            closeRegisterModal();
            sendOtp(email);
          });
}
